import React from 'react';
import { SortableContainer, arrayMove } from 'react-sortable-hoc';
import _get from 'lodash/get';

import { UiKit } from 'components';
import { useRequestReasonConfig } from '../../../context';
import Item from './Item';

const SortableList = SortableContainer(() => {
  const { data } = useRequestReasonConfig();

  const subReasonsData = _get(data, 'sub_reasons_data', {});
  const subReasons = _get(subReasonsData, 'sub_reasons', []);

  const items = subReasons.map((_, i) => <Item key={i} index={i} />);

  return (
    <UiKit.Flex direction="column" gap={16}>
      {items}
    </UiKit.Flex>
  );
});

export default function List() {
  const { data, onChange } = useRequestReasonConfig();

  const subReasonsData = _get(data, 'sub_reasons_data', {});
  const subReasons = _get(subReasonsData, 'sub_reasons', []);
  const allowMultiple = _get(subReasonsData, 'allow_multiple', true);

  const onSortEnd = ({ oldIndex, newIndex }) => {
    if (oldIndex === newIndex) return;
    const newSubRReasons = arrayMove([...subReasons], oldIndex, newIndex);
    onChange({
      sub_reasons_data: {
        allow_multiple: allowMultiple,
        sub_reasons: newSubRReasons
      }
    });
  };

  return (
    <SortableList
      items={subReasons}
      onSortEnd={onSortEnd}
      useDragHandle
      helperClass="sortable-helper"
      lockAxis="y"
      lockToContainerEdges
    />
  );
}
